import {
  MessageConfig, MessageType, NotificationType,
} from '@routific/hive';
import i18n from '../../i18n';
import formatDisplayDate from '../../helpers/formatDisplayDate';

export const getDuplicatingMessageKey = (projectId: string): string => `duplicate-route-pending-${projectId}`;

export const duplicatingMessage = (
  projectId: string,
  targetDate?: string,
  count?: number,
): MessageConfig => {
  let content: string;

  if (targetDate) {
    const formattedDate = formatDisplayDate(targetDate, true);
    content = i18n.t('notifications:duplicateRoute.loading.messageWithDate', {
      count: count ?? 1,
      date: formattedDate,
    });
  } else {
    content = i18n.t('notifications:duplicateRoute.loading.message');
  }

  return {
    content,
    key: getDuplicatingMessageKey(projectId),
    type: MessageType.LOADING,
    dataCy: 'duplicating-route-message',
    duration: 0,
  };
};

export const duplicateRouteSuccessNotification = (
  projectId: string,
  count: number,
  onClick?: () => void,
  targetDate?: string,
  selectedDate?: string,
) => {
  let linkMessage: string | undefined;
  const message = i18n.t('notifications:duplicateRoute.success.message', { count });

  if (targetDate && onClick && selectedDate !== targetDate) {
    const formattedDate = formatDisplayDate(targetDate, true);
    linkMessage = i18n.t('notifications:duplicateRoute.success.linkMessage', { count, date: formattedDate });
  }

  return {
    type: NotificationType.SUCCESS,
    id: `${projectId}-duplicate-route-success`,
    message,
    linkOnClick: onClick,
    linkMessage,
    dataCy: 'duplicate-route-success-notification',
  };
};

export const duplicateRouteFailureNotification = (projectId: string, error?: string, count?: number) => ({
  type: NotificationType.ERROR,
  id: `${projectId}-duplicate-route-failed`,
  message: error || i18n.t('notifications:duplicateRoute.failure.message', { count: count ?? 1 }),
  dataCy: 'duplicate-route-failure-notification',
});
